export interface UserState {
  user?: UserModel
  users?: UserModel[]
  endUsers?: UserModel[]
  selectedRows: number
  currentPage: number
}
export const GET_ME = 'GET_ME'
export const GET_LIST_USERS = 'GET_LIST_USERS'
export const GET_LIST_END_USERS = 'GET_LIST_END_USERS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS'
